import React from "react";
import SEO from "../components/SEO";

const CookiePolicy = () => {
  return (
    <div className="max-w-5xl mx-auto p-6 text-gray-800 leading-relaxed">
      <SEO
        title="Cookie Policy | InvestorLanes"
        description="Learn how InvestorLanes uses cookies and similar technologies to enhance your networking and startup matching experience."
        canonicalUrl="https://investorlanes.com"
      />

      <h1 className="text-4xl font-bold mb-4">Cookie Policy</h1>
      <p className="text-gray-500 text-sm mb-6"><strong>Last Updated:</strong> August 2026</p>

      <p className="mb-6">
        This Cookie Policy explains how InvestorLanes ("we", "our", or "us"), headquartered in <strong>Midrand, Johannesburg, South Africa</strong>, 
        uses cookies and similar tracking technologies on our website. In alignment with the <strong>Protection of Personal Information Act (POPIA)</strong> 
        and international data laws, we believe in being completely transparent about how we process your device data.
      </p>

      <hr className="my-8 border-gray-200" />

      <h2 className="text-2xl font-semibold mb-3">1. What are Cookies?</h2>
      <p className="mb-6">
        Cookies are small text files stored on your computer or mobile device when you visit a website. They are widely used to make websites work 
        more efficiently, keep you logged in safely, and provide telemetry analytics to the site administrators.
      </p>

      <h2 className="text-2xl font-semibold mb-3">2. How We Use Cookies</h2>
      <p className="mb-4">InvestorLanes uses cookies across three distinct categories:</p>
      <ul className="list-disc pl-6 space-y-3 mb-6">
        <li><strong>Essential Cookies (Mandatory):</strong> These are critical for core platform security and operations. They keep your login session active, protect our Payment agency pathways, and remember your security roles (Founder/Investor). Deactivating these cookies will break fundamental platform tools.</li>
        <li><strong>Analytics Cookies (Optional):</strong> These track anonymous user movements, rendering speeds, and regional channel clicks. This helps us optimize our African matchmaking algorithms and find system glitches.</li>
        <li><strong>Advertising Cookies (Optional):</strong> Our platform integrates Google AdSense. Google uses cookies to display tailored, relevant advertisements based on your visits to our site and other pages on the internet.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-3">3. Managing Your Choices</h2>
      <p className="mb-6">
        When you first access InvestorLanes, our automated compliance system asks for your preference. You can choose to accept all tracking cookies, 
        or decline optional third-party analytics and marketing parameters completely. You can also modify your options at any point via your local 
        browser settings or Google’s Ads Preference dashboard.
      </p>

      <hr className="my-8 border-gray-200" />

      <h2 className="text-2xl font-semibold mb-3">4. Contact Channels</h2>
      <p className="mb-4">For any technical inquiries regarding how our database tracks cookie identifiers, feel free to contact us:</p>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 inline-block min-w-[320px]">
        <p className="mb-1"><strong>Data Desk:</strong> support@investorlanes.com</p>
        <p><strong>Base:</strong> Midrand, Johannesburg, South Africa</p>
      </div>
    </div>
  );
};

export default CookiePolicy;
